interface Props {
  title: string | React.ReactNode;
}
import type React from 'react';
export function SectionHeader({
  title
}: Props) {
  return <div className="px-[18px] py-[10px] pb-[5px] flex items-center gap-[7px]" data-id="element-435" data-mp="2h7hzpwz7xid4">
      <div className="shb" data-id="element-436" data-mp="22ilknfyqv530" />
      <span className="text-[10px] font-bold text-[#667085] uppercase tracking-[.07em]" data-id="element-437" data-mp="22jdi6wbwjcvx">{title}</span>
    </div>;
}